import React, {useEffect, useRef, useState} from "react";
import {Calendar} from "../system/calendar/calendar";
import {
  getAgentMonthReservations,
  submitUserReservation,
  updateUserReservation
} from "../../services/reservation/reservation";
import jalaali from "jalaali-js";
import {AgentPanel} from "../system/agents_panel";
import {Button, Typography} from "@material-tailwind/react";
import {BsInfoCircle} from "react-icons/bs";
import {ReservationGuideForm} from "./reservation_guide_form";


export function ReservationManagement() {

  const myRef = useRef(null);

  const [reservations, setReservations] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(Date.now)
  const [agentId, setAgentId] = useState(false);
  const [branchId, setBranchId] = useState(false);
  const [payedReservation, setPayedReservation] = useState(null);

  const [scroll, setScroll] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);


  async function getData(jy, jm, monthDays) {
    let reservation = JSON.parse(localStorage.getItem("reservation"))
    if (reservation) {
      setAgentId(reservation.agentId)

      const result = await getAgentMonthReservations(reservation.agentId, jy, jm, monthDays);
      if (result.status === 200) {
        const {reservationList} = result.data;
        setReservations(reservationList || []);

        let reservation = localStorage.getItem("reservation")
        let discountCode = localStorage.getItem("discountCode")
        if (reservation) {
          reservation = JSON.parse(reservation)
          reservation.discountCode = discountCode

          setAgentId(reservation.agentId)
          const gorgDate = jalaali.toGregorian(parseInt(reservation.jalaliDate.split("-")[0]), parseInt(reservation.jalaliDate.split("-")[1]), parseInt(reservation.jalaliDate.split("-")[2]))
          reservation.GorgDate = `${gorgDate.gy}-${gorgDate.gm}-${gorgDate.gd}`
          reservation.SelectedSchedule = reservationList.filter(item => item.date === reservation.GorgDate)[0]
          setPayedReservation(reservation)
          localStorage.removeItem("reservation")
          localStorage.removeItem("discountCode")
        }
      }
    }

    if (localStorage.getItem("agentId")) {
      const new_agent_id = localStorage.getItem("agentId")
      setAgentId(new_agent_id)
      setScroll(!scroll);
      localStorage.removeItem("agentId")
    }

    if (localStorage.getItem("branchId")) {
      const new_branch_id = localStorage.getItem("branchId")
      setBranchId(new_branch_id)
      localStorage.removeItem("branchId")
    }

    if (agentId) {
      const result = await getAgentMonthReservations(agentId, jy, jm, monthDays);
      if (result.status === 200) {
        const {reservationList} = result.data;
        setReservations(reservationList || []);
      }
    }

    setDataLoaded(true);
  }

  useEffect(() => {
    const {jy, jm} = jalaali.toJalaali(new Date())
    const monthDays = jalaali.jalaaliMonthLength(jy, jm);
    getData(jy, jm, monthDays);
  }, [lastDataRefresh, agentId]);

  const save = async (id, title, from, to, startDate, endDate, weekDayId) => {
    const data = {
      id: id,
      title: title,
      start_time: from,
      end_time: to,
      start_date: startDate,
      end_date: endDate,
      week_day_id: weekDayId,
    };
    let result;

    if (!id) {
      result = await submitUserReservation(data);
    } else {
      result = await updateUserReservation(data);
    }

    if (result.status === 200) {
      setLastDataRefresh(Date.now())
    }

  };

  const onSelectAgent = (agentId) => {
    setAgentId(agentId);
    setScroll(!scroll);
  }

  useEffect(() => {
    myRef.current?.scrollIntoView({block: "nearest", behavior: 'smooth'});
  }, [scroll]);

  if (dataLoaded) {
    return (
      <>
        {modalOpen &&
          <ReservationGuideForm modalOpen={modalOpen} setModalOpen={setModalOpen}/>
        }
        <div className="w-full">
          <div className="flex flex-row pt-2 bg-white rounded-none justify-between">
            <div className="mb-8 flex items-center justify-between">
              <Typography variant="h5" color="blue-gray">
                درخواست مشاوره
              </Typography>
            </div>
            <Button className="flex items-center gap-x-2 py-0 h-12" size="small" variant="outlined" onClick={() => {
              setModalOpen(true)
            }}>
              <BsInfoCircle className="h-5 w-5"/>
              <Typography className="font-light">
                راهنما
              </Typography>
            </Button>
          </div>

          <div className="w-full mb-4">
            <AgentPanel
              agent_id={agentId}
              setAgentId={onSelectAgent}
              branch_id={branchId}
              setBranchId={setBranchId}
              type="consultation"
            />
          </div>

          {agentId && branchId &&
            <div className="bg-white" ref={myRef}>
              <Calendar
                Type="reservation"
                agent_id={agentId}
                branch_id={branchId}
                eventList={reservations}
                setEventList={setReservations}
                setLastDataRefresh={setLastDataRefresh}
                payedReservation={payedReservation}
                onEvent={(id, title, from, to, startDate, endDate, weekDayId) => {
                  save(id, title, from, to, startDate, endDate, weekDayId)
                }}
                onNavigate={(jy, jm, monthDays) => {
                  getData(jy, jm, monthDays);
                }}
              />
            </div>
          }
        </div>
      </>
    );
  }
}